import PageMeta from '../../components/common/PageMeta'
import AuthLayout from './AuthPageLayout'
import ResetPasswordForm from '../../features/auth/ResetPasswordForm'

export default function ResetPassword() {
  return (
    <>
      <PageMeta
        title="Recuperar Senha | Optimus - Plataforma de IA Multi-Agente"
        description="Recupere sua senha da plataforma Optimus da MDi"
      />
      <AuthLayout>
        <ResetPasswordForm />
      </AuthLayout>
    </>
  )
}
